import { Box, Button, Divider, Grid, Typography, styled } from '@mui/material'
import ApprovalApi, { ApprovalCancelReceipt, ApprovalStatus } from 'api/approval/approval.api'
import OverdueApi, { PdfOutOverdueProps } from 'api/finances/overdue.api'
import ClinicApi, { DentistInterface } from 'api/master/clinic.api'
import { setTreatment } from 'app/slice/treatment.slice'
import { selectMe } from 'app/slice/user.slice'
import BtnEditUnderline from 'assets/button/BtnEditUnderline'
import ButtonCustom from 'component/Button/ButtonCustom'
import InputSecondNewDatePicker from 'component/Input/InputSecondNewDatePicker'
import InputTextField from 'component/Input/InputTextField'
import Loading from 'component/Loading'
import ModalCustom from 'component/ModalCustom/ModalCustom'
import PdfOutStandingPayment from 'component/Print/pdfOutStandingPayment'
import FunctionPrint from 'component/Print/print'
import AutocompleteSelect from 'component/Select/AutocompleteSelect'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import { colors } from 'constants/theme'
import { ApprovalSelectorCustom } from 'features/approvel-list/approvel-list'
import _ from 'lodash'
import moment from 'moment'
import MainButton from 'new-components/buttons/main-button'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import { ReactNode, useEffect, useRef, useState } from 'react'
import CanvasDraw from 'react-canvas-draw'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { getBranch, getClinicInfo, numberFormat, toBuddhistYear } from 'utils/app.utils'

export const BoxPopupOutStandingPayment = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between',
    ".pop-body": {
        margin: ' 0 0 24px'
    },
    ".pop-footer": {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%'
    }
}))

const StyledSignatureButton = styled(Button)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  height: 100px;
  width: 200px;
  border: 1px dashed #bdbdbd;
  padding: 10px;
  color: #828282;
  background-color: transparent;
  &:hover {
    border-color: #808080;
    background-color:#F5F5F5;
  }
  &.Mui-disabled {
    background-color:#F0F0F0;
    border: 1px dashed #bdbdbd;
  }
  @media print {    
    border: none!important;
  }
`;

export const SignBox = styled(Box)(({ theme }) => ({
    position: 'relative',
    '> img': {
        position: 'absolute',
        top: 0,
    },
    '.canvas-box > div': {
        margin: 'auto',
        width: '100% !important',
        height: '300px !important',
        border: `1px solid ${colors.lightGray} `,
        borderRadius: '4px',
    },
    '.clear-box': {
        opacity: 1,
        position: 'absolute',
        top: 6,
        right: 6,
        zIndex: 5,
        '.MuiButton-root': {
            padding: '0 12px',
            minWidth: 'unset',
            borderColor: `${colors.themeThirdColor} !important`,
            color: `${colors.themeThirdColor} !important`,
            backgroundColor: `${colors.white} !important`,
            '&:hover': {
                opacity: 1
            }
        }
    },
    '&:hover': {
        '.clear-box': {
            opacity: 1
        }
    }
}));


type PopupOutStandingPaymentProps = {
    onClose: () => void
    patient: any
    treatments: any
    onSave: (data: any) => void
    type?: 'OUT' | 'OUT_FINISHED'
    disabledSelect_OutFinished?: boolean
    userId?: number
    outStandingPayment?: string;
    onCancelSuccess?: () => void
    requireFinanceAcknowledge?: boolean; // เพิ่ม setting สำหรับให้การเงินเซ็นก่อน
}

export type PDFPayloadOutStandingPaymentProps = {
    overdueTotal?: number,
    overdueDate?: string,
    overdueDateStart?: string,
    patientSignature?: string,
    doctorId?: number,
    doctorName?: string,
    doctorSignature?: string,
    managerName?: string,
    managerSignature?: string,
    financeUserName?: string,
    financeSignature?: string,
    overdueStatus?: string,
    approveItemId?: number,
    approvedRemark?: string
}

const PopupOutStandingPayment = (props: PopupOutStandingPaymentProps) => {
    const { t, i18n } = useTranslation()
    const pdfTitle = props?.type !== 'OUT_FINISHED' ? "MODAL_OUTSTANDINGPAYMENT" : "MODAL_OUTSTANDINGPAYMENT_FINISHED"
    const dispatch = useDispatch()
    const location = useLocation()
    const history = useHistory()
    const branchInfo = getClinicInfo()
    const user = useSelector(selectMe)
    const [load, setLoad] = useState<boolean>(false)
    const [doctors, setDoctors] = useState<DentistInterface[]>([])
    const [dataOut, setDataOut] = useState<any>({ signature: {} })
    const [disabledSave, setDisabledSave] = useState<boolean>(false)
    const [openModal, setOpenModal] = useState(false);
    const canvasRef: any = useRef()
    const pdfRef: any = useRef()

    const [totalTreatment, setTotalTreatment] = useState<number>(0)
    const [disabledClear, setDiabledClear] = useState<boolean>(false)

    const [isOpenPageModal, setIsOpenPageModal] = useState(false)
    const [signatureTarget, setSignatureTarget] = useState<'patient' | 'doctor' | 'manager' | 'finance' | null>(null)
    const [isCanvasDirty, setIsCanvasDirty] = useState(false)
    const [detailSignature, setDetailSignature]: any = useState({ name: '', who: '', whoEn: '' })
    const [configModal, setConfigModal]: any = useState({ modul: '', title: '', message: '', onSubmit: null })
    const [useBranchName, setUseBranchName] = useState('')
    const initialClearDone = useRef(false);

    const handleTotalTreatment = () => {
        const newPath: any = location
        if (newPath?.pathname !== '/overdue-detail') {
            const newTotalPD = props.treatments?.summeryProducts?.map((item: any) => item?.total || 0)
                .reduce((accumulator: number, currentValue: number) => accumulator + currentValue, 0);
            const newTotal = props.treatments?.summeryTreatments?.map((treatment: any) => treatment?.total || 0)
                .reduce((accumulator: number, currentValue: number) => accumulator + currentValue, 0);
            const totalDccTreat = _.sumBy(props.treatments?.summeryTreatments || [], (item: any) => parseFloat(item.totalDcc) || 0)
            const totalDccProd = _.sumBy(props.treatments?.summeryProducts || [], (item: any) => parseFloat(item.totalDcc) || 0)
            setTotalTreatment((newTotal + newTotalPD + totalDccTreat + totalDccProd) || 0)
            setDiabledClear(props?.treatments?.outStandingPayment?.overdueTotal <= 0)
        } else {
            const newTotal = props.treatments?.total
            setTotalTreatment(newTotal)
        }
    }

    useEffect(() => {
        handleTotalTreatment()
    }, [props.treatments, location])

    const loadDoctor = async () => {
        const resp = await ClinicApi.findAllDoctors()
        if (resp.status === 200) {
            const newData = resp.data.map((item: any) => {
                return {
                    dentistId: item.userId,
                    dentistFullname: item.fullname
                }
            })
            setDoctors(newData)
        }
    }

    useEffect(() => {
        loadDoctor()
    }, [])

    useEffect(() => {
        const patient = props.patient
        const treatments = props?.treatments
        const outStandingPayment = location?.pathname !== '/overdue-detail' ? treatments?.outStandingPayment : treatments?.dataOut
        const overdueStatus = location?.pathname !== '/overdue-detail' ? treatments?.overdueStatus : outStandingPayment.overdueStatus
        if (branchInfo.useBranchHead === '0') {
            setUseBranchName(branchInfo.clinicName)
        } else if (branchInfo.useBranchHead === '1') {
            setUseBranchName(branchInfo.branchName)
        } else setUseBranchName(branchInfo.clinicAndBranchName)

        const baseData = {
            patientFullName: `${patient?.firstname} ${patient?.lastname} `,
            patientFullNameEn: `${patient?.firstnameEn || patient?.firstname} ${patient?.lastnameEn || patient?.firstname} `,
            patientCode: branchInfo?.patientCodeAppointment === '1' ? patient?.cnNumber : branchInfo?.patientCodeAppointment === '0' ? patient?.branchCnNumber : patient?.snCode || '-',
            dateStart: outStandingPayment?.overdueDateStart || moment().format('YYYY-MM-DD') || '',
            doctorId: outStandingPayment?.doctorId || 0,
            doctorName: outStandingPayment?.doctorName || ''
        };
        if (overdueStatus === ApprovalStatus.CANCEL) {
            setDataOut({
                ...dataOut,
                ...baseData,
                price: '',
                dateEnd: '',
                doctorName: '',
                managerName: '',
                approvedAt: '',
                approvedRemark: '',
                signature: {
                    patientSignature: '',
                    doctorSignature: '',
                    managerSignature: '',
                    financeSignature: '',
                },
                financeUserName: '',
                overdueStatus: ApprovalStatus.CANCEL,
            });
        } else {
            const price =
                outStandingPayment?.overdueTotal === 0 && overdueStatus === 'NORMAL'
                    ? ''
                    : (outStandingPayment?.overdueTotal ?? '');
            const newDataOut = {
                ...baseData,
                price: price,
                dateEnd: outStandingPayment?.overdueDate || '',
                doctorName: outStandingPayment?.doctorName || '',
                managerName: outStandingPayment?.managerName || '',
                approvedAt: outStandingPayment?.approvedAt || '',
                approvedRemark: outStandingPayment?.approvedRemark || '',
                ...outStandingPayment,
                signature: {
                    patientSignature: location?.pathname !== '/overdue-detail' ? outStandingPayment?.patientSignature : outStandingPayment?.signature?.patientSignature,
                    doctorSignature: location?.pathname !== '/overdue-detail' ? outStandingPayment?.doctorSignature : outStandingPayment?.signature?.doctorSignature,
                    managerSignature: location?.pathname !== '/overdue-detail' ? outStandingPayment?.managerSignature : outStandingPayment?.signature?.managerSignature,
                    financeSignature: (overdueStatus === "WAITING_FINANCE" || overdueStatus === "NORMAL") ? '' : (location?.pathname !== '/overdue-detail' ? (outStandingPayment?.financeSignature || outStandingPayment?.signature?.financeSignature) : outStandingPayment?.signature?.financeSignature),
                },
                financeUserName: overdueStatus === "WAITING_FINANCE" && !(outStandingPayment?.financeSignature || outStandingPayment?.signature?.financeSignature) ? '' : (outStandingPayment?.financeUserName || outStandingPayment?.financeName || outStandingPayment?.signature?.financeUserName || outStandingPayment?.signature?.financeName || ''),
                overdueStatus: overdueStatus,
            };
            setDataOut({ ...dataOut, ...newDataOut });
        }
    }, [props.patient, props.treatments]);

    useEffect(() => {
        if (props.userId && doctors.length > 0 && (dataOut.overdueStatus === ApprovalStatus.CANCEL || dataOut.overdueStatus === 'NORMAL')) {
            const currentDoctor = doctors.find(d => d.dentistId === props.userId);
            if (currentDoctor) {
                setDataOut((prev: any) => ({
                    ...prev,
                    doctorId: currentDoctor.dentistId,
                    doctorName: currentDoctor.dentistFullname
                }));
            }
        }
    }, [props.userId, doctors]);

    const isTrue = (value: any) => value ? true : false;
    
    useEffect(() => {
        const { dateStart, dateEnd, price, doctorId, signature, overdueStatus } = dataOut || {};
        const { patientSignature, doctorSignature, managerSignature, financeSignature } = signature || {};
        const hasRequiredFields = dateStart && dateEnd && price && doctorId && patientSignature;

        // เช็ค pathname เพื่อกำหนดว่าต้องบังคับลายเซ็นพนักงานการเงินหรือไม่
        const isPaymentCreate = location?.pathname === '/payment/create';
        const isTreatment = location?.pathname === '/treatments';

        // ถ้าเปิด requireFinanceAcknowledge และเป็น /payment-create ต้องมีลายเซ็นพนักงานการเงิน
        // ถ้าเป็น /treatment ไม่ต้องบังคับลายเซ็นพนักงานการเงิน
        const hasFinanceSignature = !props.requireFinanceAcknowledge ||
            (isTreatment ? true : (isPaymentCreate ? financeSignature : true));

        if (hasRequiredFields &&
            (props?.type === 'OUT_FINISHED' || isTrue(dataOut?.signature?.doctorSignature)) &&
            (props?.type !== 'OUT_FINISHED' || isTrue(dataOut?.signature?.managerSignature)) &&
            hasFinanceSignature || dataOut?.price === 0) {
            // ถ้า status = WAITING_FINANCE และมี financeSignature แล้ว → อนุญาตให้บันทึกได้ (เพื่อส่งลิ้งยืนยัน)
            // ในหน้า /payment/create ถ้า requireFinanceAcknowledge === true และมี financeSignature แล้ว ให้บันทึกได้แม้ overdueStatus เป็น PENDING
            if (financeSignature) {
                setDisabledSave(false)
            } else if ((dataOut.overdueStatus === 'NORMAL' || (dataOut.overdueStatus !== ApprovalStatus.PENDING))) {
                setDisabledSave(false)
            } else {
                setDisabledSave(true)
            }
        } else setDisabledSave(true)
    }, [dataOut, props.type, props.requireFinanceAcknowledge, location?.pathname])

    useEffect(() => {
        if (dataOut.overdueStatus && !initialClearDone.current) {
            if (dataOut.overdueStatus === ApprovalStatus.PENDING) {
                setDataOut((prev: any) => ({
                    ...prev,
                    signature: {
                        ...prev.signature,
                        managerSignature: ''
                    }
                }));
            }
            initialClearDone.current = true;
        }
    }, [dataOut]);

    const handleChangeDataOut = (key: string, value: any) => {
        if (key === 'price' && value.length > 1) {
            const price = value.split('')
            if (price[0] === '0') {
                const newArray = price.filter((item: any) => item !== "0");
                value = newArray.join('')
            }
        }
        const newDataOut = { ...dataOut }
        newDataOut[key] = value

        if (key === 'price' && Number(value) !== Number(dataOut.price)) {
            newDataOut.signature = {
                ...newDataOut.signature,
                patientSignature: '',
                doctorSignature: '',
                managerSignature: '',
                financeSignature: '',
            }
        }

        setDataOut(newDataOut)
    }

    const clearCanvas = () => {
        if (canvasRef.current) {
            canvasRef.current.clear()
            setIsCanvasDirty(false)
        }
    }

    const handleSignature = (type: "submit" | "clear") => {

        if (type === "submit" && signatureTarget) {
            if (canvasRef.current) {

                const base64 = canvasRef.current.canvasContainer.childNodes[1].toDataURL('image/jpg')
                let base64string: any = `${base64} `.split(',')
                base64string = base64string[base64string.length - 1]
                const newSignature = { ...dataOut.signature, [`${signatureTarget}Signature`]: base64string }

                // ถ้าเป็น finance signature ให้บันทึกชื่อผู้ใช้ด้วย
                const updateData: any = { ...dataOut, signature: newSignature }
                if (signatureTarget === 'finance' && user) {
                    updateData.financeUserName = user.fullname || ''
                }

                setDataOut(updateData)
            }
        }
        setIsOpenPageModal(false)
        setSignatureTarget(null)
        setIsCanvasDirty(false)
    };

    const clearStampedSignature = (type: 'patient' | 'doctor' | 'manager' | 'finance') => {
        const newSignature = { ...dataOut.signature, [`${type}Signature`]: '' }
        setDataOut({ ...dataOut, signature: newSignature })
    };

    const onClearPdf = () => {
        const newData = {
            overdueTotal: '',
            overdueDate: null,
            overdueDateStart: moment().format('YYYY-MM-DD'),
            patientSignature: '',
            doctorId: 0,
            doctorName: '',
            doctorSignature: '',
            managerName: '',
            managerSignature: '',
            financeName: '',
            financeUserName: '',
            financeSignature: '',
            overdueStatus: ApprovalStatus.CANCEL,
            approveItemId: 0,
            approvedAt: '',
            approvedRemark: '',
        };
        const currentOutStandingPayment = props.treatments.outStandingPayment;
        const updatedOutStandingPayment = { ...currentOutStandingPayment, ...newData };

        dispatch(setTreatment({ value: { ...props.treatments, outStandingPayment: updatedOutStandingPayment } }));
        setDataOut((prev: any) => ({
            ...prev,
            price: '',
            dateEnd: null,
            dateStart: moment().format('YYYY-MM-DD'),
            doctorId: 0,
            doctorName: '',
            signature: {
                patientSignature: '',
                doctorSignature: '',
                managerSignature: '',
                financeSignature: '',
            },
            financeName: '',
            financeUserName: '',
            overdueStatus: ApprovalStatus.CANCEL,
        }));
        return newData;
    }


    const onCloseModal = () => {
        dispatch(setTreatment({ value: { ...props.treatments, outStandingPayment: { ...props.treatments.newOutStandingPayment } } }));
        props.onClose();
    }

    const onSubmit = async (status?: any) => {
        setOpenModal(false)
        setLoad(true)
        const newPath: any = location
        if (newPath?.pathname !== '/overdue-detail') {
            // ถ้า status === 'NORMAL' ให้เคลียร์ข้อมูล baseData
            const baseData: any = status === 'NORMAL' ? {
                approveItemId: dataOut?.approveItemId,
                overdueTotal: 0,
                overdueDate: null,
                overdueDateStart: null,
                patientSignature: '',
                doctorId: 0,
                doctorName: '',
                doctorSignature: '',
                managerName: '',
                managerSignature: '',
                financeUserName: '',
                financeSignature: '',
            } : {
                approveItemId: dataOut?.approveItemId,
                overdueTotal: Number(dataOut?.price) || 0,
                overdueDate: dataOut?.dateEnd || '',
                overdueDateStart: dataOut?.dateStart || '',
                patientSignature: dataOut?.signature?.patientSignature || '',
                doctorId: dataOut?.doctorId || 0,
                doctorName: dataOut?.doctorName || '',
                doctorSignature: dataOut?.signature?.doctorSignature || '',
                managerName: '',
                managerSignature: dataOut?.signature?.managerSignature || '',
                financeUserName: dataOut?.financeUserName || '',
                financeSignature: dataOut?.signature?.financeSignature || '',
            }

            // ส่ง overdueStatus = 'PENDING' เฉพาะกรณีสร้างคำขอจากหน้า /treatments และมี approveItemId
            // (กดจาก PopupOutStandingPayment บนหน้ารักษา)
            const isTreatment = newPath?.pathname === '/treatments' || newPath?.pathname?.includes('/treatments');
            // เช็คว่า requireFinanceAcknowledge เป็น true หรือ string "1"
            const isRequireFinance = props.requireFinanceAcknowledge === true || props.requireFinanceAcknowledge;
            const isPaymentCreate = newPath?.pathname === '/payment/create';
            const isNormal = status === 'NORMAL';
            let requestOverdueValue = '1';
            if (isTreatment && isRequireFinance) {
                requestOverdueValue = '0';
            } else if (isPaymentCreate && isNormal) {
                requestOverdueValue = '0';
            }

            // ถ้ามี approveItemId และต้องตั้ง overdueStatus เป็น PENDING และ requestOverdue === "0"
            // ให้ลบลายเซ็นพนักงานการเงินออก
            const shouldClearFinanceSignature = (newPath?.pathname === '/treatments' && dataOut?.approveItemId && requestOverdueValue === '0');

            // กำหนด overdueStatus ตามเงื่อนไข
            let overdueStatus: any = undefined;
            // กรณี 1: ถ้า status === 'NORMAL' หรือ overdueStatus === 'NORMAL' → ตั้งเป็น NORMAL
            if (!dataOut?.approvalItemId && status === 'NORMAL') {
                overdueStatus = 'NORMAL'
            } else if (isPaymentCreate && isNormal) {
                overdueStatus = 'NORMAL'
            } else if (newPath?.pathname === '/treatments' && isRequireFinance) {
                overdueStatus = "WAITING_FINANCE";
            }

            const newData = overdueStatus
                ? {
                    ...baseData,
                    overdueStatus: overdueStatus,
                    ...(shouldClearFinanceSignature ? { financeUserName: '', financeSignature: '', managerName: '', managerSignature: '' } : {})
                }
                : baseData

            // ถ้ามี approveItemId และ status = WAITING_FINANCE และมี financeSignature → เรียก API financeAcknowledge
            // if (dataOut?.approveItemId &&
            //     dataOut?.signature?.financeSignature) {
            //     try {
            //         await ApprovalApi.financeAcknowledge(dataOut.approveItemId, {
            //             financeSignature: dataOut.signature.financeSignature
            //         })
            //         notiSuccess(t('APPROVAL.MESSAGE.SUC_CREATE'))
            //         if (props.onCancelSuccess) { props.onCancelSuccess() }
            //         props.onClose()
            //         setLoad(false)
            //         return
            //     } catch (error: any) {
            //         notiError(error?.response?.data?.message || t('APPROVAL.MESSAGE.ERROR'))
            //         setLoad(false)
            //         return
            //     }
            // }           
            // ถ้าเป็นหน้า /treatments และ requireFinanceAcknowledge === "1" requestOverdue ต้องส่งเป็น 0
            // แต่ถ้าเป็นหน้าอื่น ให้ส่งเป็น 1

            if (props.outStandingPayment === '0') {
                const payload = { ...newData, requestOverdue: requestOverdueValue }
                props.onSave(payload);
            } else {
                const payloadWithRequestOverdue = { ...newData, requestOverdue: requestOverdueValue }
                dispatch(setTreatment({ value: { ...props.treatments, outStandingPayment: { ...newData } } }))
                props.onSave(payloadWithRequestOverdue)
            }
            props.onClose()
        } else if (newPath?.pathname === '/overdue-detail' && props.type !== 'OUT_FINISHED') {
            const newPayload: any = {
                overdueTotal: Number(dataOut?.price) || 0,
                overdueDate: dataOut?.dateEnd || '',
                overdueDateStart: dataOut?.dateStart || '',
                patientSignature: dataOut?.signature?.patientSignature || '',
                doctorId: dataOut?.doctorId || 0,
                doctorName: dataOut?.doctorName || '',
                doctorSignature: dataOut?.signature?.doctorSignature || '',
                // financeUserName: dataOut?.financeUserName || '',
                // financeSignature: dataOut?.signature?.financeSignature || ''
            }
            if (newPayload) {
                await ApprovalApi.createApprovalOverdue(props.patient?.patientCaseId, newPayload).then((res) => {
                    notiSuccess(t('APPROVAL.MESSAGE.SUC_CREATE'))
                }).finally(() => {
                    if (props.onCancelSuccess) { props.onCancelSuccess() }
                    props.onClose()
                })
            };
        }
        else {
            const newData: PdfOutOverdueProps = {
                overdueTotal: Number(dataOut?.price) || 0,
                hasPrint: props?.type !== 'OUT_FINISHED' ? 0 : 1,
                patientCaseId: dataOut?.patientCaseId || 0,
                overdueDate: dataOut?.dateEnd || '',
                overdueDateStart: dataOut?.dateStart || '',
                patientSignature: dataOut?.signature?.patientSignature || '',
                doctorId: dataOut?.doctorId || 0,
                doctorName: dataOut?.doctorName || '',
                doctorSignature: dataOut?.signature?.doctorSignature || '',
                managerName: '',
                managerSignature: dataOut?.signature?.managerSignature || '',
                // financeUserName: dataOut?.financeUserName || '',
                // financeSignature: dataOut?.signature?.financeSignature || '',
            }
            await OverdueApi.pdfOutOverdue(dataOut?.orderId, newData).then((res) => {
                notiSuccess(t('TREATMENT_SUMMARY.MESSAGE.SUCCESS.SAVE'), '', null, null, 'register-page')
            }).finally(() => {
                if (props.onCancelSuccess) { props.onCancelSuccess() }
                props.onSave(newData)
                props.onClose()
            })
        }
        setLoad(false)
    }

    const handleConfirmSubmit = () => {
        // ถ้า requireFinanceAcknowledge === true จะเปิด modal แค่ในหน้า /payment/create
        if (props.requireFinanceAcknowledge === true) {
            if (location?.pathname === '/payment/create' && props.outStandingPayment === '1') {
                setConfigModal({
                    modul: 'confirm',
                    title: t('รออนุมัติ'),
                    message: t('รอการได้รับการแก้ไขอนุมัติ'),
                    onSubmit: onSubmit
                })
                setOpenModal(true)
            } else {
                onSubmit()
            }
        } else if (props.outStandingPayment === '1' && location?.pathname !== '/overdue-detail') {
            setConfigModal({
                modul: 'confirm',
                title: t('รออนุมัติ'),
                message: t('รอการได้รับการแก้ไขอนุมัติ'),
                onSubmit: onSubmit
            })
            setOpenModal(true)
        } else {
            onSubmit()
        }
    }

    const handleFloat = (input: number) => {
        if (input?.toString()?.length && input?.toString()[input?.toString()?.length - 1] === '.') {
            const newInput: number = input
            return newInput
        } else {
            return input
        }
    }


    const SignatureButton = ({ type, children, disabled, className, name, subTitle1, subTitle2 }: { type: "doctor" | "patient" | "manager" | "finance", children: ReactNode, disabled?: boolean, className?: string, name: string, subTitle1: string, subTitle2: string }) => {
        return (
            <StyledSignatureButton
                id="signature-button"
                className={`${className} signature - button`}
                disabled={disabled ?? false}
                variant="outlined"
                onClick={() => {
                    setSignatureTarget(type)
                    setIsOpenPageModal(true)
                    setDetailSignature({ name: name, who: subTitle1, whoEn: subTitle2 })
                }}
            >{disabled ? <></> : children}</StyledSignatureButton>
        );
    };

    const renderSignatureBox = (
        type: 'patient' | 'doctor' | 'manager' | 'finance',
        title: string,
        name: string,
        signature: string,
        subTitle1: string,
        subTitle2: string,
        // alignItems: any = 'center',
        disabled?: boolean
    ) => {
        const disabledManager = props.type === 'OUT_FINISHED' && location?.pathname === '/overdue-detail'
        // ถ้า requireFinanceAcknowledge === true และอยู่หน้า /treatments ให้ปิดช่องลายเซ็น finance (เฉพาะการกรอกใหม่)
        const disabledFinance = type === 'finance' && props.requireFinanceAcknowledge && location?.pathname === '/treatments'
        const isDisabled = Boolean(disabledFinance || disabled || (type === 'manager' && !disabledManager))
        // สำหรับปุ่มล้างลายเซ็น: finance และ doctor จะ disabled เมื่อ overdueStatus เป็น PENDING
        const isDisabledClear = Boolean(
            (type === 'finance' || type === 'doctor')
                ? (dataOut.overdueStatus === ApprovalStatus.PENDING)
                : (disabled || (type === 'manager' && !disabledManager))
        )
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {signature ? (
                    <Box sx={{ position: 'relative' }}>
                        <Box
                            sx={{
                                border: "1px solid #E0E0E0",
                                borderRadius: "6px",
                                padding: "10px",
                                height: "100px",
                                width: "200px",
                            }}
                        >
                            <Box display={'flex'} justifyContent={'center'}>
                                <img
                                    src={`data:image/png;base64,${signature}`}
                                    style={{ width: '190px', height: '90px', objectFit: 'contain' }}
                                    alt={`${type} signature`}
                                />
                            </Box>
                        </Box>
                        <Box sx={{ position: 'absolute', top: 5, right: 3, zIndex: 1, paddingRight: '3px' }}>
                            <MainButton
                                variant={'outlined'}
                                title={t('MODAL_TREATMENT_CONSENT.BUTTON.CLEAR_CANVAS')}
                                type='danger'
                                onClick={() => clearStampedSignature(type)}
                                disabled={isDisabledClear}
                                style={{
                                    fontSize: '12px',
                                    minWidth: 'auto',
                                    backgroundColor: 'white',
                                    height: '25px'
                                }}
                            />
                        </Box>
                    </Box>
                ) : (
                    <SignatureButton
                        type={type}
                        disabled={isDisabled}
                        name={name}
                        subTitle1={subTitle1}
                        subTitle2={subTitle2}
                    >
                        <BtnEditUnderline color={'#808080'} width='20' height='20' />
                        <Typography sx={{ fontWeight: '500', fontSize: '16px' }}>{t(`PDF_INVOICE.PDF.CLICK_SIGNATURE`)}</Typography>
                    </SignatureButton>
                )}
                <Typography sx={{ textAlign: "center", marginTop: "10px" }}>
                    {name || "..........................................."}
                </Typography>
                <Typography sx={{ textAlign: "center", color: "#828282" }}>
                    {subTitle1}
                </Typography>
                <Typography sx={{ textAlign: "center", color: "#828282" }}>
                    {subTitle2}
                </Typography>
            </Box>
        )
    }

    const handleOpenCancelModal = () => {
        setConfigModal({ modul: 'cancel', title: t('ยกเลิกใบขอค้างชำระ'), message: t('คุณต้องการยกเลิกใบขอค้างชำระ ใช่หรือไม่'), onSubmit: null })
        setOpenModal(true)
    }

    const submitCancel = async () => {
        const treatments = props?.treatments
        const outStandingPayment = location?.pathname !== '/overdue-detail' ? treatments?.outStandingPayment : treatments?.dataOut
        const approveItemId = outStandingPayment.approveItemId
        const overdueStatus = treatments.overdueStatus

        // ถ้าไม่มี approveItemId และ status เป็น WAITING_FINANCE ให้เปลี่ยน overdueStatus เป็น NORMAL แล้วเรียก onSubmit
        if (overdueStatus === "WAITING_FINANCE") {
            onSubmit("NORMAL")
            return
        }

        // กรณีปกติที่มี approveItemId
        const newPayload: ApprovalCancelReceipt = {
            requestReason: '',
            requestUserName: '',
            requestUserId: 0,
            approveRemark: '',
            refId: location?.pathname !== '/overdue-detail' ? props.patient.patientCase.patientCaseId : props.patient.patientCaseId,
            branchId: dataOut.branchId || getBranch(),
            status: ApprovalStatus.CANCEL,
            managerSignature: '',
        };

        await ApprovalApi.approvalCancelReceipt(approveItemId, newPayload).then((res) => {
            notiSuccess(t('TREATMENT_SUMMARY.MESSAGE.SUCCESS.SAVE'))
            if (props.onCancelSuccess) { props.onCancelSuccess() }
            onClearPdf()
        }).catch((e) => {
            const error = e.response?.data?.message
            const errorMessage = ["IS_APPROVED", "IS_CANCEL"]
            notiError(t('APPROVELLIST.MESSAGE.ERROR'))
        }).finally(() => {
            setOpenModal(false)
            props.onClose()
        })
    }

    return (
        <>
            <Loading show={load} />
            <AlertModal
                title={configModal.title}
                message={configModal.message}
                isOpen={openModal}
                type={configModal.modul === 'cancel' ? 'error' : 'warning'}
                handleClose={() => setOpenModal(false)}
                onCancel={{ onClick: () => configModal.modul === 'cancel' ? setOpenModal(false) : onSubmit(), title: configModal.modul === 'cancel' ? t('BUTTON.CANCEL') : t('BUTTON.ENTER') }}
                onSubmit={{ onClick: () => submitCancel(), title: t('BUTTON.SUBMIT') }}
                onCloseSubmit={configModal.modul !== 'cancel'}
            />
            <ModalCustom
                title={t(`${pdfTitle}.TITLE`)}
                modalStyle={`modal - outstandingpayment`}
                closeButton
                size={'xl'}
                onClose={onCloseModal}
                component={(
                    <BoxPopupOutStandingPayment>
                        <Box className={`pop - body`} marginBottom={'16px'}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} container justifyContent="space-between" alignItems="center">
                                    <Grid item>
                                        <Typography fontSize="16px" fontWeight={500}>{t('MODAL_OUTSTANDINGPAYMENT.FORM.HOSPITALNAME')} {branchInfo?.clinicName || ''}</Typography>
                                    </Grid>

                                    {props.outStandingPayment === '1' &&
                                        (dataOut.overdueStatus === ApprovalStatus.PENDING ||
                                            dataOut.overdueStatus === "WAITING_FINANCE" ||
                                            dataOut.overdueStatus === ApprovalStatus.REJECT ||
                                            dataOut.overdueStatus === ApprovalStatus.APPROVED) && (
                                            <Grid item>
                                                <ApprovalSelectorCustom
                                                    approval={dataOut.overdueStatus}
                                                    disabled
                                                    userApprovel={{
                                                        fullname: dataOut.managerName,
                                                        date: dataOut.approvedAt,
                                                    }}
                                                    onClick={handleOpenCancelModal}
                                                />
                                            </Grid>
                                        )}
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <InputSecondNewDatePicker
                                                required
                                                key={'dateStart'}
                                                label={t('MODAL_OUTSTANDINGPAYMENT.FORM.DATESTART')}
                                                value={dataOut?.dateStart || ''}
                                                onchange={(e: any) => { handleChangeDataOut('dateStart', e) }}
                                                allowClear={(props?.type !== "OUT_FINISHED")}
                                                onClear={() => handleChangeDataOut('dateStart', '')}
                                                maxDate={dataOut?.dateEnd ? new Date(dataOut?.dateEnd) : undefined}
                                                disableFuture
                                                disabled
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <AutocompleteSelect
                                                labelId='doctorId'
                                                inputLabel={t('MODAL_OUTSTANDINGPAYMENT.FORM.DOCTOR')}
                                                required
                                                options={doctors}
                                                getOptionLabel={(option: any) => option?.dentistFullname || ''}
                                                filterOptions={(option: any) => option?.dentistFullname || ''}
                                                isOptionEqualToValue={(option: any, value: any) => Number(option?.dentistId) === Number(value?.dentistId)}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <Box {...props}>
                                                            {option?.dentistFullname || ''}
                                                        </Box>
                                                    )
                                                }}
                                                onchange={(e: any, val: any) => {
                                                    const newDoctorId = val?.dentistId || 0;
                                                    const newData = {
                                                        doctorId: newDoctorId,
                                                        doctorName: val?.dentistFullname || ''
                                                    };

                                                    const newSignature = { ...dataOut.signature };
                                                    if (dataOut.doctorId !== newDoctorId) {
                                                        newSignature.doctorSignature = '';
                                                    }

                                                    setDataOut({
                                                        ...dataOut,
                                                        ...newData,
                                                        signature: newSignature
                                                    });
                                                }}
                                                value={_.find(doctors, (d) => Number(d?.dentistId) === Number(dataOut?.doctorId)) || null}
                                                disabled={props.outStandingPayment === '0' ? false : props?.disabledSelect_OutFinished || dataOut.overdueStatus === ApprovalStatus.PENDING}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <InputSecondNewDatePicker
                                                required
                                                key={'dateEnd'}
                                                label={t('MODAL_OUTSTANDINGPAYMENT.FORM.DATEEND')}
                                                value={dataOut?.dateEnd || ''}
                                                onchange={(e: any) => { handleChangeDataOut('dateEnd', e) }}
                                                allowClear
                                                onClear={() => handleChangeDataOut('dateEnd', '')}
                                                disablePast
                                                minDate={dataOut?.dateStart ? new Date(dataOut?.dateStart) : undefined}
                                                disabled={props.outStandingPayment === '0' ? false : dataOut.overdueStatus === ApprovalStatus.PENDING}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px', height: '100%' }}>
                                                <Box>
                                                    {t('MODAL_OUTSTANDINGPAYMENT.FORM.PRICE')}<span style={{ color: colors.statusInactive }}>*</span>
                                                </Box>
                                                <Box>
                                                    <InputTextField
                                                        name={'price'}
                                                        value={String(dataOut?.price) ?? ''}
                                                        onchange={(e) => {
                                                            const inputValue = e.target.value;
                                                            const sanitizedValue = inputValue.replace(/,/g, '');
                                                            const pattern = /^[0-9.]+$/;
                                                            if (pattern.test(sanitizedValue) && !isNaN(sanitizedValue as any)) {
                                                                const value: number = sanitizedValue as any;
                                                                const nonNegativeValue = value >= 0 ? handleFloat(value) : 0;
                                                                const newPrice = Number(totalTreatment || 0) >= Number(nonNegativeValue || 0) ? nonNegativeValue : totalTreatment
                                                                handleChangeDataOut('price', newPrice)
                                                            } else {
                                                                const newData = inputValue === "" ? 0 : dataOut?.price || 0
                                                                const newPrice = Number(totalTreatment || 0) >= Number(newData || 0) ? newData : totalTreatment
                                                                handleChangeDataOut('price', newPrice)
                                                            }
                                                        }}
                                                        disabled={props.outStandingPayment === '0' ? false : props?.disabledSelect_OutFinished || dataOut.overdueStatus === ApprovalStatus.PENDING}
                                                    />
                                                </Box>
                                                <Box>
                                                    {t('CURRENCY_CHANGE.TH')}
                                                </Box>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box
                                        sx={{
                                            backgroundColor: "#F5F5F5",
                                            padding: "20px",
                                            borderRadius: "10px",
                                            marginTop: "20px",
                                            color: "#000",
                                        }}
                                    >
                                        <Box display={'flex'} flexDirection={'row'}>
                                            <Box display={'flex'} justifyContent={'flex-start'} marginBottom={2} width={'50%'}>
                                                <Typography fontSize={'16px'} fontWeight={600}>{t('MODAL_OUTSTANDINGPAYMENT.FORM.IAM', { patientName: dataOut?.patientFullName || '' })}</Typography>
                                            </Box>
                                            <Box display={'flex'} justifyContent={'flex-start'} marginBottom={2} marginLeft={'16px'} width={'50%'}>
                                                <Typography fontSize={'16px'} fontWeight={600}>CN:{dataOut?.patientCode}</Typography>
                                            </Box>
                                        </Box>
                                        <Typography>
                                            {t(`${pdfTitle}.FORM.DETAIL_EXAM`,
                                                {
                                                    // hospitalName: branchInfo?.hospitalName,
                                                    branchName: useBranchName,
                                                    dateStart: dataOut?.dateStart ? toBuddhistYear(moment(dataOut?.dateStart)) : '-',
                                                    dateEnd: dataOut?.dateEnd ? toBuddhistYear(moment(dataOut?.dateEnd)) : '-',
                                                    price: dataOut?.price ? numberFormat(dataOut?.price || 0, 2) : '0.00',
                                                    paymentId: dataOut?.paymentNumber || '-'
                                                })}
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container sx={{ marginTop: "20px" }} spacing={2}>
                                        <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-start' } }}>
                                            {renderSignatureBox(
                                                'patient',
                                                'Patient Signature',
                                                dataOut?.patientFullName,
                                                dataOut?.signature?.patientSignature,
                                                t('MODAL_TREATMENT_CONSENT.SIGN.PATIENT'),
                                                "Patient's Signature",
                                                dataOut.overdueStatus === ApprovalStatus.PENDING
                                            )}
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <Grid container spacing={2} sx={{ justifyContent: { xs: 'center', md: 'flex-end' } }}>
                                                {props.type !== 'OUT_FINISHED' && <Grid item xs={12} sm={6} md="auto">
                                                    {renderSignatureBox(
                                                        'doctor',
                                                        'Doctor Signature',
                                                        dataOut?.doctorName,
                                                        dataOut?.signature?.doctorSignature,
                                                        t('MODAL_TREATMENT_CONSENT.SIGN.DOCTOR'),
                                                        t('PDF_INVOICE.PDF.DOCTOR_SIGNATURE_EN'),
                                                        dataOut.overdueStatus === ApprovalStatus.PENDING
                                                    )}
                                                </Grid>}
                                                {/* ช่องลายเซ็นพนักงานการเงิน - แสดงเมื่อเปิดใช้ requireFinanceAcknowledge */}
                                                {props.requireFinanceAcknowledge && props.outStandingPayment === '1' && (
                                                    <Grid item xs={12} sm={6} md="auto">
                                                        {renderSignatureBox(
                                                            'finance',
                                                            'Finance Signature',
                                                            // ถ้า WAITING_FINANCE และยังไม่มี signature ให้ไม่แสดงชื่อ แต่ถ้ามี signature แล้วให้แสดงชื่อ
                                                            dataOut.overdueStatus === "WAITING_FINANCE" && !dataOut?.signature?.financeSignature ? '' : (dataOut?.financeUserName || ''),
                                                            // ถ้า WAITING_FINANCE และยังไม่มี signature ให้ไม่แสดงลายเซ็น แต่ถ้ามี signature แล้วให้แสดง
                                                            dataOut.overdueStatus === "WAITING_FINANCE" && !dataOut?.signature?.financeSignature ? '' : (dataOut?.signature?.financeSignature || ''),
                                                            t('MODAL_OUTSTANDINGPAYMENT.FORM.FINANCE'),
                                                            "Finance Staff",
                                                            // ในหน้า /payment/create ให้ finance สามารถเซ็นได้แม้ status เป็น PENDING
                                                            location?.pathname === '/payment/create'
                                                                ? false
                                                                : (dataOut.overdueStatus === ApprovalStatus.PENDING || dataOut.overdueStatus === ApprovalStatus.APPROVED || dataOut.overdueStatus === ApprovalStatus.REJECT)
                                                        )}
                                                    </Grid>
                                                )}
                                                <Grid item xs={12} sm={6} md="auto">
                                                    {renderSignatureBox(
                                                        'manager',
                                                        'Manager Signature',
                                                        dataOut?.managerName,
                                                        // ถ้า WAITING_FINANCE และยังไม่มี signature ให้ไม่แสดงลายเซ็น แต่ถ้ามี signature แล้วให้แสดง
                                                        dataOut.overdueStatus === "WAITING_FINANCE" && !dataOut?.signature?.managerSignature
                                                            ? ''
                                                            : (dataOut.overdueStatus !== ApprovalStatus.PENDING ? dataOut?.signature?.managerSignature : ''),
                                                        t('MODAL_OUTSTANDINGPAYMENT.FORM.MANAGER'),
                                                        "Manager",
                                                        (dataOut.overdueStatus === ApprovalStatus.PENDING || props.outStandingPayment === '1' && dataOut.overdueStatus === ApprovalStatus.APPROVED || props.outStandingPayment === '1' && dataOut.overdueStatus === ApprovalStatus.REJECT)
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {props?.type === "OUT_FINISHED" &&
                                <Box className='mt-3'>
                                    {t('MODAL_OUTSTANDINGPAYMENT_FINISHED.FORM.REMARK')}
                                </Box>
                            }
                        </Box>
                        <Divider sx={{ margin: '0 0 24px !important', borderColor: '#E5E5E5 !important' }} />

                        {dataOut?.overdueStatus === "REJECT" &&
                            <Box
                                marginTop={'-16px'}
                                marginBottom={'8px'}
                                sx={{
                                    padding: '12px',
                                }}
                            >
                                <span style={{ color: '#B00020', }}>{t('เหตุผลในการไม่อนุมัติ')}:</span> {dataOut?.approvedRemark || ''}
                            </Box>
                        }

                        <Box className={`pop - footer`} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Box sx={{ width: '100px', button: { width: '100%' } }}>
                                <FunctionPrint
                                    content={() => pdfRef.current}
                                    removeIfram
                                    trigger={() => (
                                        <MainButton
                                            disabled={props.type === 'OUT_FINISHED' && location?.pathname === '/overdue-detail' && !disabledSave ? false : dataOut.overdueStatus !== ApprovalStatus.APPROVED || disabledSave}
                                            variant={"outlined"}
                                            title={t("BUTTON.PRINT")}
                                            type='primary'
                                        />
                                    )}
                                    style={'@page { size: 210mm 450px;  margin: 0cm;  } @media print { body { -webkit-print-color-adjust: exact; } '}
                                    beforePrint={() => {
                                        if (props.type === 'OUT_FINISHED' && location?.pathname === '/overdue-detail') onSubmit()
                                    }}
                                />

                            </Box>
                            <Box sx={{ display: 'flex', gap: '16px' }}>
                                <Box sx={{ width: '100px', button: { width: '100%' } }}>
                                    <MainButton
                                        onClick={() => onClearPdf()}
                                        title={t('DOCTOR_NOTE.BUTTON.RESET')}
                                        type='danger'
                                        variant={"outlined"}
                                        disabled={disabledSave || dataOut?.overdueStatus === ApprovalStatus.PENDING}
                                    />
                                </Box>
                                {/* } */}
                                <Box sx={{ width: '100px', button: { width: '100%' } }}>
                                    <MainButton
                                        variant={"outlined"}
                                        type='secondary'
                                        title={t("BUTTON.CANCEL")}
                                        onClick={onCloseModal}
                                    />
                                </Box>
                                <Box sx={{ width: '100px', button: { width: '100%' } }}>
                                    <MainButton
                                        disabled= { disabledSave ||
                                            // ในหน้า /payment/create ถ้า requireFinanceAcknowledge === true และมี financeSignature แล้ว ให้บันทึกได้แม้ overdueStatus เป็น PENDING
                                            (dataOut.overdueStatus === ApprovalStatus.PENDING &&
                                                !(location?.pathname === '/payment/create' &&
                                                    props.requireFinanceAcknowledge &&
                                                    dataOut?.signature?.financeSignature)) }
                                        title={t("BUTTON.SAVE")}
                                        onClick={handleConfirmSubmit}
                                        variant='contained'
                                        type='primary'
                                    />
                                </Box>
                            </Box>
                        </Box>
                        <Box ref={pdfRef} className={'print-show'}>
                            <PdfOutStandingPayment
                                dataOut={dataOut}
                                type={props?.type || 'OUT'}
                                requireFinanceAcknowledge={props.requireFinanceAcknowledge}
                            />
                        </Box>
                    </BoxPopupOutStandingPayment>
                )}
            />
            <PageModal
                isOpen={isOpenPageModal}
                size={'S'}
                title={t('PDF_INVOICE.PDF.SIGNATURE')}
                handleClose={() => handleSignature("clear")}
                onSubmit={{ onClick: () => handleSignature("submit"), disabled: !isCanvasDirty }}
                onCancel={{ onClick: () => handleSignature("clear") }}
                overflow
            >
                <Box>
                    <Box className={`signatureWrap - box w - 100 mt - 3 mt - md - 0`}>
                        <Box>
                            <SignBox >
                                <Box className={`clear-box`}>
                                    <ButtonCustom variant={'outlined'} textButton={t('MODAL_TREATMENT_CONSENT.BUTTON.CLEAR_CANVAS')} onClick={clearCanvas} />
                                </Box>
                                <Box className="canvas-box" onMouseDown={() => setIsCanvasDirty(true)} onTouchStart={() => setIsCanvasDirty(true)}>
                                    <CanvasDraw
                                        ref={canvasRef}
                                        hideGrid
                                        hideInterface
                                        brushRadius={2}
                                        lazyRadius={2}
                                        brushColor={colors.black}
                                    />
                                </Box>
                                <Box>
                                    <Typography sx={{ textAlign: "center", marginTop: "10px" }}>
                                        {detailSignature?.name || "..........................................."}
                                    </Typography>
                                    <Typography sx={{ textAlign: "center", color: "#828282" }}>
                                        {detailSignature?.who}
                                    </Typography>
                                    <Typography sx={{ textAlign: "center", color: "#828282" }}>
                                        {detailSignature?.whoEn}
                                    </Typography>
                                </Box>
                            </SignBox>
                        </Box>
                    </Box>
                </Box>

            </PageModal>
        </>
    )
}

export default PopupOutStandingPayment